<!--
  - Copyright (C) 2018-2019
  - All rights reserved, Designed By www.joolun.com
  - 注意：
  - 本软件为www.joolun.com开发研制，未经购买不得使用
  - 购买后可获得全部源代码（禁止转卖、分享、上传到码云、github等开源平台）
  - 一经发现盗用、分享等行为，将追究法律责任，后果自负
-->
<template>
  <div class="code-phone-div" style="">
    <!-- <img class="iconImg" src="../../static/login/hi.png" alt="" /> -->

    <!-- <div class="code-phone-title">
      <div class="header">
        <div class="left">捷运途 · 云账号登录</div>
          <div class="register right">
            <el-link type="primary" style="margin-right:10px;font-size: 0.15rem;" @click="$router.push({ path: '/garbageRegister' })"
              >注册泥尾</el-link
            >
            <el-link type="primary" @click="$router.push({ path: '/companyAuth' })" style="font-size: 0.15rem;"
              >注册企业</el-link
            >
        </div>
      </div>


      <span class="role" v-for="role in roles" :class="{ active: activeRole === role.name }" @click="setActiveRole(role)" >{{ role.name }}</span>
    </div> -->

    <el-form :rules="formRules" ref="form" :model="formData" label-width="0">
      <el-form-item prop="phone">
        <div class="phone">
          <img
            src="../../static/login/dl_phone.png"
            alt=""
            class="phone-icon"
          />
          <div class="phone-start">86</div>
          <i class="el-icon-arrow-down"> </i>
          <input
            type="text"
            v-model="formData.phone"
            :disabled="type == '3'"
            placeholder="请输入手机号码"
            :maxlength="11"
            placeholder-class="placeholder"
          />
        </div>
      </el-form-item>

      <el-form-item prop="code" style="">
        <div class="code">
          <div class="input-code">
            <img class="code-icon" src="../../static/login/yzm.png" alt="" />
            <input
              type="text"
              v-model="formData.code"
              :disabled="type == '3'"
              @keyup.enter.native="handleDone"
              placeholder="请输入短信验证码"
              :maxlength="6"
              @change="handleInputChange"
            />
          </div>
          <div class="send-code" @click="handleSend">
            {{ msgText }}
          </div>
        </div>
      </el-form-item>

      <div style="height: 2px; border-bottom: dashed 1px #d0d5dd"></div>

      <div class="agree">
        <el-checkbox v-model="checked" checked></el-checkbox>
        <div class="agree-text">
          我同意<span @click="toPrivacy">《隐私协议》</span>和<span
            @click="toUse"
            >《软件使用服务协议》</span
          >
        </div>
      </div>
      
    </el-form>
    <button class="login-btn" :style="stylea" @click="handleDone">
        {{ type == "1" ? "登录" : "确定" }}
      </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validatePhone } from "@/util/validate";
import { sendCode } from "@/api/upms/phone";
const MSGINIT = "发送验证码",
  MSGSCUCCESS = "${time}秒后重发",
  MSGTIME = 60;
export default {
  name: "codePhoneDiv",
  props: {
    //1、登录；2、绑定；3、解绑
    type: {
      type: String,
    },
    phone: {
      type: String,
    },
    roleType: {
      type: String,
    },
  },
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (validatePhone(value)[0]) {
        callback(new Error(validatePhone(value)[1]));
      } else {
        callback();
      }
    };
    const validatorCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入6位数的验证码"));
      } else {
        callback();
      }
    };
    return {
      roles: [
        { name: "施工单位", id: 2 },
        { name: "车队长", id: 1 },
        // { name: '挖机车主', id: 6 },
        // { name: '泥尾端', id: 7 }
      ],
      activeRole: "施工单位",
      isFogertPass: false,
      checked: false,
      msgText: MSGINIT,
      msgTime: MSGTIME,
      msgKey: false,
      stylea:'height: 39px;background-color: #E2EAF0;border-radius: 4px;color: rgba(143, 165, 179, 1);border: 0px;',
      formData: {
        phone: "",
        code: "",
        roleType: 2,
      },
      formRules: {
        phone: [{ required: true, trigger: "blur", validator: validatorPhone }],
        code: [{ required: true, trigger: "blur", validator: validatorCode }],
      },
    };
  },
  watch: {
    roleType: {
      handler(val) {
        this.formData.roleType = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.formData.phone = this.phone;
  },
  destroyed() {},
  mounted() {},
  beforeDestroy() {},
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    toPrivacy() {
      window.open(
        "https://jab9.top/h5/#/pages/privacyAgreement/privacyAgreement"
      );
    },
    toUse() {
      window.open(
        "https://jab9.top/h5/#/pages/customerService/customerService"
      );
    },
    // 设置cookie
    setCookie(c_name, c_pwd, c_state, exdays) {
      const exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      window.document.cookie =
        "username" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "state" + "=" + c_state + ";path=/;expires=" + exdate.toGMTString();
    },
    // 读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        const arr = document.cookie.split("; ");
        for (let i = 0; i < arr.length; i++) {
          const arr2 = arr[i].split("=");
          console.log(arr[2]);
          if (arr2[0] === "username") {
            this.username = arr2[1];
          } else if (arr2[0] === "password") {
            this.password = arr2[1];
          } else if (arr2[0] === "state") {
            this.checked = Boolean(arr2[1]);
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie("", "", false, -1);
    },
    handleSend() {
      if (this.msgKey) return;
      if (validatePhone(this.formData.phone)[0]) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      this.msgKey = true;
      sendCode({
        mobile: this.formData.phone,
        type: this.type,
        roleType: this.roleType,
      })
        .then((response) => {
          this.msgKey = false;
          if (response.data.code == "0") {
            this.$message.success(response.data.msg || "验证码发送成功");
            this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime);
            this.msgKey = true;
            const time = setInterval(() => {
              this.msgTime--;
              this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime);
              if (this.msgTime == 0) {
                this.msgTime = MSGTIME;
                this.msgText = MSGINIT;
                this.msgKey = false;
                clearInterval(time);
              }
            }, 1000);
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch(() => {
          this.msgKey = false;
        });
    },
    handleDone() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message({
              showClose: true,
              message: "请先勾选协议",
              type: "success",
            });
            return;
          }

          // if (this.isFogertPass === true) {
          //   this.setCookie(this.username, this.password, true, 7)
          // } else {
          //   this.clearCookie()
          // }
          this.$emit("handleDone", this.formData, this.type);
        }
      });
    },
    setActiveRole(role) {
      this.activeRole = role.name;
      this.formData.roleType = role.id;
    },
    handleInputChange(value) {
      if (this.formData.code.length == 6 && this.formData.phone.length == 11) {
        this.stylea =
          "height: 39px;background-color: rgba(53, 177, 255, 1);border-radius: 4px;color: #FFFFFF;border: 0px;";
      } else {
        this.stylea =
          "height: 39px;background-color: #E2EAF0;border-radius: 4px;color: rgba(143, 165, 179, 1);border: 0px;";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.code {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-code {
  width: 100%;
  display: flex;
  align-items: center;
  height: 46px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #c7cedd;
  margin-right: 6px;

  .code-icon {
    width: 18px;
    height: 19px;
    padding-left: 13px;
    padding-right: 5px;
  }
  input {
    border: none;
    height: 100%;
    width: 100%;
    border-radius: 4px;
  }
}
.send-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 106px;
  height: 48px;
  background: #35b1ff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  cursor: pointer;
}
.code-phone-div {
  padding-bottom: 0.2rem;
  .header {
    padding-bottom: 0.5rem;
    display: flex;
    .left {
      font-size: 0.25rem;
      text-align: left;
    }
    .right {
      font-size: 0.15rem;
      margin: auto;
      // padding-left: 0.4rem;
      color: #35b1ff;
    }
  }
}

.register {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.qrcode {
  display: flex;
  font-size: 16px;
  align-items: center;
  color: #2b2a2a;
  justify-content: center;
  margin-top: 8px;
  .scan {
    font-size: 0.17rem;
    font-weight: 700;
    width: 12px;
    margin-right: 8px;
  }
  img {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 8px;
  }
  .android,
  .ios {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.17rem;
    .svg-icon {
      font-size: 0.4rem;
    }
  }
}

// .code-phone-submit {
//   display: block !important;
//   margin: 40px auto 10px auto !important;
//   width: 200px;
//   height: 48px;
//   font-size: 14px !important;
//   text-align: center;
//   border-radius: 50px !important;
//   border: 0px;
//   box-shadow: rgba(152, 22, 244, 0.19) 0px 5px 10px 2px;
// }

.status {
  display: none;
}

/* 根据 Vue 绑定的 activeRole 变量值显示对应状态 */
.active .status {
  display: block;
}

/* 样式：点击时的反馈 */
.role {
  cursor: pointer;
  padding-left: 0.13rem;
  padding-right: 0.13rem;
  margin: auto;

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 0.18rem;
  color: #8fa5b3;
  text-align: left;
  font-style: normal;
  line-height: 25px;
  height: 61px;
}
.active {
  font-weight: 500; /* 设置选中状态的样式，比如加粗 */
  color: #35b1ff; /* 设置选中状态的颜色 */
  padding-bottom: 5px;
  border-bottom: solid 2px #35b1ff;
}
/deep/.el-input-group__prepend {
  background: #fff;
  border-right: none;
}
.phone {
  display: flex;
  align-items: center;
  height: 48px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #c7cedd;
  .phone-icon {
    width: 16px;
    height: 21px;
    padding-left: 12px;
  }
  .phone-start {
    font-weight: 400;
    font-size: 14px;
    color: #7a8d99;
    padding-left: 12px;
  }
  i {
    padding-left: 12px;
    padding-right: 17px;
    font-weight: 400;
    font-size: 14px;
    color: #7a8d99;
  }
  span {
  }
  input {
    border-radius: 4px;
    border: none;
    width: 100%;
    height: 100%;
  }
}
input::-webkit-input-placeholder {
  font-weight: 400;
  font-size: 14px;
  color: #7a8d99;
}
.placeholder {
  font-weight: 400;
  font-size: 14px;
  color: #7a8d99;
}
.agree {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .agree-text {
    margin-left: 6px;
    font-weight: 400;
    font-size: 14px;
    color: #2e3033;
    span {
      cursor: pointer;
      color: #35b1ff;
    }
  }
}
.login-btn {
  margin-top: 46px;
  width: 100%;
  height: 48px;
  background: #e2eaf0;
  font-weight: 500;
  font-size: 14px;
  color: #8fa5b3;
  border: none;
  cursor: pointer;
}
</style>
